import { atom } from 'jotai'

export const raFormDataAtom = atom({})

export const listCategoryAtom = atom([])
export const listProductCodeAtom = atom([])
export const listPaymentFPXAtom = atom('')

export const touchedAtom = atom({})
